import Vue from 'vue'

import 'vuetify/dist/vuetify.min.css'
import Vuetify from 'vuetify'

window.axios = require('axios');

Vue.use(Vuetify)
